import { render, staticRenderFns } from "./SplititHostedFields.vue?vue&type=template&id=0a21cb66&scoped=true&"
import script from "./SplititHostedFields.vue?vue&type=script&lang=js&"
export * from "./SplititHostedFields.vue?vue&type=script&lang=js&"
import style0 from "./SplititHostedFields.vue?vue&type=style&index=0&id=0a21cb66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21cb66",
  null
  
)

export default component.exports